import { DrilldownTableConfigContextProvider } from 'features/drilldown/components/table/config/DrilldownTableConfigContext'
import {
  DrilldownTable,
  DrilldownTablePanelData,
} from 'features/drilldown/components/table/DrilldownTable'
import {
  NII_CAMPAIGN_TITLE,
  NII_RESULTS_FILTERS,
  TooltipParagraph,
} from 'features/drilldown/panels/impl/niiLibraResultsTable/NiiLibraResultsPanel'
import { FC, ReactNode } from 'react'

import { expandLatestCompleteLibraTicketRecordsToZoneRows } from './expandLibraNiiTicketZoneRows'
import {
  DEFAULT_NII_LIBRA_RESULTS_BY_ZONE_TABLE_PANEL_DATA,
  NII_LIBRA_RESULTS_BY_ZONE_TABLE_CONFIG_PROPS,
} from './NiiLibraResultsByZoneTable'

export const DEFAULT_NII_RESULTS_BY_ZONE_PANEL_DATA: DrilldownTablePanelData = {
  ...DEFAULT_NII_LIBRA_RESULTS_BY_ZONE_TABLE_PANEL_DATA,
  title: 'NII Analysis Results by Zone',
}

export const NII_LIBRA_RESULTS_BY_ZONE_TITLE_TOOLTIP: ReactNode = (
  <>
    <TooltipParagraph>
      Scoped to <b>{NII_CAMPAIGN_TITLE}</b>, and only shows the latest{' '}
      <b>complete</b> or <b>fully drafted</b> ticket for each analysis.
    </TooltipParagraph>
    <TooltipParagraph>
      Each ticket is split into one row per zone, so you will often see multiple
      rows for the same analysis &mdash; one for each zone&apos;s details.
    </TooltipParagraph>
  </>
)

export const NiiLibraResultsByZonePanel: FC = () => {
  return (
    <DrilldownTableConfigContextProvider
      {...NII_LIBRA_RESULTS_BY_ZONE_TABLE_CONFIG_PROPS}
      additionalRolodexFilters={NII_RESULTS_FILTERS}
      paginatedTableOptions={{
        ...NII_LIBRA_RESULTS_BY_ZONE_TABLE_CONFIG_PROPS.paginatedTableOptions,
        expandRecords: expandLatestCompleteLibraTicketRecordsToZoneRows,
      }}>
      <DrilldownTable />
    </DrilldownTableConfigContextProvider>
  )
}
